import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';
// כתובת השרת החיצוני - יש להחליף בכתובת האמיתית
const EXTERNAL_API_URL = process.env.VUE_APP_EXTERNAL_API_URL || 'https://shimushon.work';
const DOWNLOAD_CLIENT_ID = process.env.VUE_APP_DOWNLOAD_CLIENT_ID || 'drive-it-netfree';

const apiClient = axios.create({
	baseURL: API_URL,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json'
	}
});

const externalApiClient = axios.create({
	baseURL: EXTERNAL_API_URL,
	withCredentials: false,
	headers: {
		'Content-Type': 'application/json'
	}
});

const UPLOAD_ROUTES = {
	auto: '/upload',
	single: '/upload',
	playlist: '/upload/playlist',
	channel: '/upload/channel'
};

export default {
	// בדיקת זמינות תוכן בנטפרי
	async checkNetfree(url) {


		// try {

		// 	const response = await fetch(`https://www.google.com/~netfree/test-url?u=${url}`, {
		// 		method: 'GET',
		// 		headers: { 'Content-Type': 'application/json' },

		// 	});
		// 	const result = await response.json();
		// 	return result;
		// } catch (err) {
		// 	console.error('Error checking NetFree availability:', err);
		// 	return {
		// 		status: 'error',
		// 		message: 'Failed to check availability',
		// 		error: err.message
		// 	};
		// }




		return apiClient.post('/check_netfree', { url });
	},
	// העלאת תוכן דרך השרת החיצוני
	uploadVideo(
		url,
		tokens,
		folderId = null,
		formatType = 'video',
		qualityPreference = 'best',
		contentKind = 'auto'
	) {
		const payload = {
			url,
			tokens,
			drive_folder_id: folderId,
			client_id: DOWNLOAD_CLIENT_ID,
			format_type: formatType,
			quality_preference: qualityPreference
		};

		const uploadRoute = UPLOAD_ROUTES[contentKind] || UPLOAD_ROUTES.auto;

		return externalApiClient.post(uploadRoute, payload);
	},

	// העלאת קובץ cookies בפורמט Netscape לשירות ההורדות
	async uploadYouTubeCookies(file) {
		const formData = new FormData();
		formData.append('file', file, 'cookies.txt');
		formData.append('client_id', DOWNLOAD_CLIENT_ID);

		let response;
		try {
			response = await fetch(`${EXTERNAL_API_URL.replace(/\/+$/, '')}/upload_cookies`, {
				method: 'POST',
				body: formData
			});
		} catch (error) {
			throw new Error('לא ניתן להתחבר לשירות ההורדות. יש לבדוק את החיבור ואת הגדרות ה-CORS.');
		}

		let result = {};
		try {
			result = await response.json();
		} catch (error) {
			// תשובת שגיאה שאינה JSON תטופל באמצעות הודעת ברירת המחדל למטה.
		}

		if (!response.ok) {
			throw new Error((result && result.error) || 'העלאת העוגיות נכשלה');
		}

		return result && typeof result === 'object' ? result : {};
	},

	// בדיקת סטטוס משימת ההעלאה
	checkTaskStatus(taskId) {
		return externalApiClient.get(`/api/status/${taskId}`);
	},

	// הפניה לאימות Google
	getAuthUrl() {
		return `${API_URL}/auth`;
	}
};
